import * as React from 'react';
import { cn } from '@restworld/utils-common';

export interface WrapperProps {
  children?: React.ReactNode;
  id?: string;
  className?: string;
}

export const Wrapper = React.forwardRef<HTMLDivElement, WrapperProps>(({ children, id, className }, ref) => (
  <div ref={ref} id={id} className={cn('flex flex-col gap-4', className)}>
    {children}
  </div>
));
Wrapper.displayName = 'Wrapper';

export default Wrapper;
